module.exports = __webpack_public_path__ + "img/domain-influence.fd81242c.svg";